import { useMemo } from 'react';

import { Breakpoint, useBreakpoint } from 'hooks/use-breakpoint';

const useResponsiveNbCols = (nbCols: number, cols?: Record<Breakpoint, number>): number | null => {
    const breakpoint = useBreakpoint();

    if (!breakpoint) {
        return null;
    }

    if (cols && cols[breakpoint]) {
        return cols[breakpoint];
    }

    if (breakpoint === 'xs') {
        return Math.floor(nbCols / 4) || 1;
    }

    if (breakpoint === 'sm') {
        return Math.ceil(nbCols / 3) || 1;
    }

    if (breakpoint === 'md') {
        return Math.ceil(nbCols / 2) || nbCols;
    }

    if (breakpoint === 'lg') {
        return Math.ceil(nbCols / 1.75) || nbCols;
    }

    return nbCols;
};

export { useResponsiveNbCols };
